export { default } from './Total';
